import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerScanWithoutLoginGet = {
    path: "/scanner/scan-without-login",
    namespace: "real-cookie-banner/v1",
    method: RouteHttpVerb.GET
};
export { locationRestScannerScanWithoutLoginGet };
